import blockAndTxs, {
    createTxList,
    createBlockList
} from './blockAndTxs'
import axios from './axios'
// 首页需要展示的区块条数
const BLOCK_AMOUNT_IN_FIRST_PAGE = 5

// 首页需要展示的交易条数
const TX_AMOUNT_IN_FIRST_PAGE = 5

export default {
    mixins: [blockAndTxs],
    data() {
        return {
            blockList: [],
            txList: [],
            tabActive: true
        }
    },
    computed: {
        maxHeight() {
            return this.$store.state.maxHeight
        },
        maxHash() {
            return this.$store.state.maxHash
        }
    },
    mounted() {

        this.getBlock();
        this.timerRefresh = setInterval(() => {
            this.getBlock();
        }, 20000);
        return

    },
    watch: {
        maxHeight() {
            // 最新区块高度变更时
            clearTimeout(this.timer)
            this.timer = null
        }
    },
    methods: {
        async getBlock() {
            const { data: _data } = await axios.get("/api/v1/bc");
            this.blockList = _data.blocks;
            this.txList = _data.transactions;
        },
    }
}